'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var colors = require('../base/colors.js');
var colors_bg = require('./colors.bg.js');
var colors_border = require('./colors.border.js');

/**
 * Text Colors.
 */ const textColor = {
    neutral: {
        DEFAULT: `light-dark(${colors.colors.black['500']}, ${colors.colors.black['25']})`,
        subtlest: `light-dark(${colors.colors.black['300']}, ${colors.colors.black['300']})`,
        subtle: `light-dark(${colors.colors.black['400']}, ${colors.colors.black['100']})`,
        strong: `light-dark(${colors.colors.black['700']}, ${colors.colors.white})`
    },
    info: `light-dark(${colors.colors.blue['600']}, ${colors.colors.blue['100']})`,
    invert: `light-dark(${colors.colors.white}, ${colors.colors.black.DEFAULT})`,
    interactive: `light-dark(${colors.colors.blue['500']}, ${colors.colors.blue['100']})`,
    success: `light-dark(${colors.colors.green['600']}, ${colors.colors.green['90']})`,
    warning: `light-dark(${colors.colors.yellow['600']}, ${colors.colors.yellow['100']})`,
    error: `light-dark(${colors.colors.red['600']}, ${colors.colors.red['100']})`,
    severe: `light-dark(${colors.colors.red['800']}, ${colors.colors.violet['75']})`,
    processing: `light-dark(${colors.colors.violet['600']}, ${colors.colors.violet['100']})`,
    icon: {
        neutral: {
            DEFAULT: `light-dark(${colors.colors.black['400']}, ${colors.colors.black['50']})`,
            strong: `light-dark(${colors.colors.black['500']}, ${colors.colors.white})`,
            subtle: `light-dark(${colors.colors.black['300']}, ${colors.colors.black['90']})`
        },
        primary: `light-dark(${colors.colors.blue['400']}, ${colors.colors.blue['200']})`,
        info: `light-dark(${colors.colors.blue['400']}, ${colors.colors.blue['200']})`,
        invert: `light-dark(${colors.colors.white}, ${colors.colors.black.DEFAULT})`,
        success: `light-dark(${colors.colors.green['500']}, ${colors.colors.green['200']})`,
        warning: `light-dark(${colors.colors.yellow['500']}, ${colors.colors.yellow['300']})`,
        error: `light-dark(${colors.colors.red['500']}, ${colors.colors.red['200']})`,
        processing: `light-dark(${colors.colors.violet['500']}, ${colors.colors.violet['200']})`,
        interactive: `light-dark(${colors.colors.blue['500']}, ${colors.colors.blue['300']})`,
        accent: {
            green: `light-dark(${colors.colors.green['500']}, ${colors.colors.green['200']})`,
            blue: `light-dark(${colors.colors.blue['400']}, ${colors.colors.blue['200']})`,
            purple: `light-dark(${colors.colors.purple['300']}, ${colors.colors.purple['300']})`,
            violet: {
                DEFAULT: `light-dark(${colors.colors.violet['500']}, ${colors.colors.violet['200']})`,
                strong: `light-dark(${colors.colors.violet['600']}, ${colors.colors.violet['300']})`
            },
            pink: `light-dark(${colors.colors.red['400']}, ${colors.colors.red['300']})`,
            orange: `light-dark(${colors.colors.orange['500']}, ${colors.colors.orange['300']})`
        }
    },
    code: {
        linenum: `light-dark(${colors.colors.black['300']}, ${colors.colors.black['100']})`,
        prop: `light-dark(${colors.colors.blue['600']}, ${colors.colors.blue['100']})`,
        operator: `light-dark(${colors.colors.black.DEFAULT}, ${colors.colors.white})`,
        punctuation: `light-dark(${colors.colors.black.DEFAULT}, ${colors.colors.white})`,
        string: `light-dark(${colors.colors.violet['600']}, ${colors.colors.violet['100']})`,
        number: `light-dark(${colors.colors.green['600']}, ${colors.colors.green['90']})`,
        boolean: `light-dark(${colors.colors.violet['600']}, ${colors.colors.violet['100']})`,
        comment: `light-dark(${colors.colors.black['300']}, ${colors.colors.black['300']})`
    },
    border: {
        // for places we need to use a text color to render an SVG border currentColor
        neutral: {
            DEFAULT: colors_border.borderColor.neutral.DEFAULT
        }
    },
    bg: {
        // for places we need to use a text color to render an SVG background currentColor
        neutral: {
            DEFAULT: colors_bg.backgroundColor.neutral.DEFAULT
        },
        info: colors_bg.backgroundColor.info,
        success: colors_bg.backgroundColor.success,
        warning: colors_bg.backgroundColor.warning,
        bold: {
            interactive: {
                DEFAULT: colors_bg.backgroundColor.bold.interactive.DEFAULT,
                bright: colors_bg.backgroundColor.bold.interactive.bright,
                hovered: colors_bg.backgroundColor.bold.interactive.hovered
            }
        }
    }
};
/**
 * Export as Tailwind Preset.
 */ const preset = {
    content: [],
    theme: {
        extend: {
            textColor
        }
    }
};

exports.default = preset;
exports.textColor = textColor;
//# sourceMappingURL=colors.text.js.map
